import State from "slotworks/state-machine/states/state";
import DSComponents from "components/components";
import { PotType } from "components/pots/coinpots-component";

export default class PotsAction extends State {

    public onEnter() {
        DSComponents.coinPots.burstCoins(PotType.MULTIPLIER).then(() => this.complete());
    }

}